import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loginUser } from "../Services/AllServices";
import { setName, setProfile, setToken, setUserID } from "../Storage/Storage";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "../styles/SignIn.css";
import brainImage from "../images/brainImage.svg";
import anavuLogo from "../images/iiit_logo.png";
import backArrow from "../images/backArrow.png";

const SignIn = () => {
  const [loginData, setLoginData] = useState({ login: "", password: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State for password visibility
  const navigate = useNavigate(); // Initialize navigate for routing

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setLoginData({ ...loginData, [id]: value });
  };
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    
    if (!isValidEmail(loginData.login)) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }
    
    setLoading(true);
  
    await loginUser(loginData, (result) => {
      if (result.code === 200 && result.status === "success") {
        const { name, profile, access_token, ID, downloadCount } = result.data;
        setName(name);
        setProfile(profile);
        setToken(access_token);
        setUserID(ID);
  
        if (profile === "Student") {
          navigate("/learner");
        } else if (profile === "Teacher") {
          navigate("/teacher");
        } else if (profile === "Moderator") {
          navigate("/moderator/video-management");
        } else {
          setErrorMessage("Unknown profile. Please contact support.");
        }
      } else {
        setErrorMessage(result.message || "Something went wrong. Please try again.");
      }
      setLoading(false);
    });
  };
  
  

  return (
    <>
      <div className="logo-container">
        <a href="/">
          <img src={anavuLogo} alt="Anavu Logo" className="logo" />
          <div className="logo-text">Anavu</div>
        </a>
      </div>
      <div className="signin_page">
        <div className="signin_left">
          <a href="/" className="signin_backarrow">
            <img src={backArrow} alt="back arrow" />
          </a>
          <div className="signin-container">
            <h2>Sign in</h2>
            <p>Please login to continue to your account.</p>

            <form onSubmit={handleSubmit}>
              <div className="signin-input-container">
                <input
                  type="text"
                  id="login"
                  placeholder="Email or phone number"
                  value={loginData.login}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="login">Email or phone number</label>
              </div>

              <div className="signin-input-container">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Password"
                  value={loginData.password}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="password">Password</label>
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  className="password-icon"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}
              <div className="keep-logged-in">
                <input type="checkbox" id="keepLoggedIn" />
                <label htmlFor="keepLoggedIn">Keep me logged in</label>
              </div>

              <button type="submit" className="signin-btn" disabled={loading}>
                {loading ? "Signing in..." : "Sign in"}
              </button>
            </form>

            <div className="separator">
              <span>or</span>
            </div>

            <div className="signup-link">
              Need an account? <a href="/signup">Create one</a>
            </div>
          </div>
        </div>

        <div className="signin_right">
          <img src={brainImage} alt="Brain" />
        </div>
      </div>
    </>
  );
};

export default SignIn;
